const maritalStatuses = [
  {
    value: 'single',
    text:  'Solteiro(a)',
  },
  {
    value: 'married',
    text:  'Casado(a)',
  },
  {
    value: 'divorced',
    text:  'Divorciado(a)/Separado(a)',
  },
  {
    value: 'widowed',
    text:  'Viúvo(a)',
  },
];
export default maritalStatuses;
